import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  fullWidth: {
    width: '100%',
  },
  listItem: {
    gap: '20px',
  },
  iconUploadContainer: {
    height: '100%',
    minHeight: '40px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconUploadPreviewContainer: {
    textAlign: 'center',
    border: '1px dashed #ccc',
    marginLeft: 10,
    height: '70px',
    width: '70px',
    minHeight: '50px',
    minWidth: '50px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  iconPreview: { maxWidth: '100%', maxHeight: '100%' },
  imageUploadContainer: {
    height: '250px',
    display: 'flex',
    alignItems: 'center',
  },
  imageUploadPreviewContainer: {
    height: '100%',
    flex: 1,
    margin: '10px',
    border: '1px dashed #ccc',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  imagePreview: { maxWidth: 300, maxHeight: 'calc(100% - 20px)' },
})

export { useStyles }
